import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  inputBackgroundColor: {
    backgroundColor: "#F4F4F4",
  },
  title: {
    fontWeight: "bold",
    marginBottom: theme.spacing(3),
  },
  inputLabel: {
    fontWeight: "bold",
  },
}))

export default styles
